import { Box } from "@mui/material";
import { PuffLoader } from "react-spinners";
const Loader = ({ color }) => {
  return (
    <Box sx={{ paddingRight: "200px" }}>
      <PuffLoader color={color} speedMultiplier={1} radius={2} width={4} />
    </Box>
  );
};

export { Loader };
